import { initialState } from './slice';

// Persisted authentication can be restored before non-persisted feature state exists.
const selectPlatform = (state) => state['feature/platform'] || initialState;

export default selectPlatform;
